import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { ActionType, useProductMedia, useProductMediaDispatch } from "./FilesContext";
import { uploadFile } from "@admin/domain/files/api";

type Props = {
    mediaId?: string | number;
};

export default function AddVideoButton({ mediaId }: Props) {
    const dispatch = useProductMediaDispatch();
    const productMedia = useProductMedia();

    const [uploadedVideo, setUploadedVideo] = useState<{
        file?: File;
        preview?: File | null;
    }>({});

    const [showVideoModal, setShowVideoModal] = useState(false);
    const [loadStatus, setLoadStatus] = useState(false);

    const uploadVideo = async (): Promise<void> => {
        if (!uploadedVideo.file || !uploadedVideo.preview) {
            return;
        }

        setLoadStatus(true);

        const mediaFile = await uploadFile(uploadedVideo.file, uploadedVideo.preview);

        dispatch({
            type: mediaId ? ActionType.AddMobileAppFile : ActionType.AddFile,
            productMediaFile: mediaFile,
            mediaId,
        });

        setLoadStatus(false);
        setShowVideoModal(false);
    };

    const addVideo = (): void => {
        if (!productMedia.length) {
            alert(`Видео не может быть загружено. Сначала необходимо загрузить основное изображение товара`);
            return;
        }

        setShowVideoModal(true);
    };

    return (
        <>
            <button type="button" className="btn btn-primary" onClick={addVideo}>
                Добавить видео {mediaId ? `для МП` : ``}
            </button>
            <Modal show={showVideoModal}>
                <Modal.Header>
                    <Modal.Title>Загрузка видео</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <label className="form-label">Видео файл</label>
                        <input
                            type="file"
                            required
                            className="form-control"
                            name="file"
                            accept="video/*"
                            onChange={(event): void =>
                                setUploadedVideo((prevState) => ({
                                    ...prevState,
                                    file: event.target.files?.item(0) as File,
                                }))
                            }
                        />
                    </div>
                    <div className="mt-5">
                        <label className="form-label">Превью для видео файла</label>
                        <input
                            type="file"
                            required
                            className="form-control"
                            name="file"
                            accept="image/*"
                            onChange={(event): void =>
                                setUploadedVideo((prevState) => ({
                                    ...prevState,
                                    preview: event.target.files?.item(0) as File,
                                }))
                            }
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowVideoModal(false)}>
                        Закрыть
                    </button>
                    <button className="btn btn-primary" onClick={uploadVideo} disabled={loadStatus}>
                        {!loadStatus ? (
                            <span>Загрузить</span>
                        ) : (
                            <span>
                                <Spinner
                                    className="me-3"
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Загрузка...
                            </span>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
